var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0957 21.0134H5.90426C2.64867 21.0134 0 18.3647 0 15.1091V5.90426C0 2.64861 2.64867 0 5.90426 0H24.0957C27.3514 0 30 2.64861 30 5.90426V15.1092C30 18.3647 27.3514 21.0134 24.0957 21.0134V21.0134ZM5.90426 1.75781C3.61793 1.75781 1.75781 3.61787 1.75781 5.90426V15.1092C1.75781 17.3955 3.61793 19.2556 5.90426 19.2556H24.0957C26.3821 19.2556 28.2422 17.3955 28.2422 15.1092V5.90426C28.2422 3.61787 26.3821 1.75781 24.0957 1.75781H5.90426Z",
    fill: "#F5F5F5",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0876 16.1355C11.9398 16.1355 11.7917 16.0983 11.658 16.0234C11.3806 15.8679 11.2087 15.5747 11.2087 15.2566V5.64258C11.2087 5.32266 11.3826 5.02799 11.6626 4.8733C11.9426 4.71855 12.2846 4.72822 12.5555 4.89856L20.3026 9.76945C20.56 9.93129 20.7155 10.2147 20.7137 10.5187C20.7119 10.8228 20.553 11.1043 20.2937 11.2631L12.5466 16.0063C12.4059 16.0923 12.2469 16.1355 12.0876 16.1355V16.1355ZM12.9666 7.23334V13.688L18.1677 10.5036L12.9666 7.23334Z",
    fill: "#F5F5F5",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayYoutube);
export default __webpack_public_path__ + "static/media/GrayYoutube.4a3b339af8b6134f005fdfcbf83eb01a.svg";
export { ForwardRef as ReactComponent };